<a class="app-menu-item" [routerLink]="['/dealer/offers']" [routerLinkActive]="['active']" [ngClass]="{'active': routerLinkActiveOffer}">{{ 'dealer:menu:offers:label' | translate }}</a>
<a class="app-menu-item" [routerLink]="['/dealer/settings']" [routerLinkActive]="['active']">{{ 'dealer:menu:settings:label' | translate }}</a>
<hr>
<a class="app-menu-item-other" [routerLink]="['/step/1']">{{ 'dealer:menu:configurator:label' | translate }} <i class="icon">arrowright</i></a>
